<script setup>

import { inject } from 'vue';
import ListeParametres from './listeParametres/ListeParametres.vue';
import DetailParametre from './detailParametre/DetailParametre.vue';

const { parametres } = defineProps({
  parametres: Array
});

const selectionSchema = inject('selectionSchema');

</script>

<template>
	<div class="panel-lateral contenu-onglet-schema">
		<ListeParametres :parametres="parametres" />
		<DetailParametre v-if="selectionSchema.parametre" :parametre="selectionSchema.parametre" />
	</div>
</template>

<style scoped>
</style>